<template>
  <div id="app">
    <div id="header">
      <img id="title" src="./assets/SmartReport.png" alt="Smart Report">
      <span id="user" v-if="userName">
        <span v-if="userName.length > 1 && userName.length < 8">User: </span>
        <span v-if="userName.length > 1">{{ userName }}</span>
      </span>
    </div>
    <el-menu mode="horizontal" router :id="menuId" ref="menu" :default-active="activeIndex">
      <el-menu-item index="/kimmu" v-show="isSeishain" :disabled="menuDisable">勤務実績</el-menu-item>
      <el-menu-item index="/kimmuK" v-show="!isSeishain" :disabled="menuDisable">勤務実績</el-menu-item>
      <el-menu-item index="/gyomu" v-show="isSeishain" :disabled="menuDisable">業務報告</el-menu-item>
      <el-menu-item index="/gyomuK" v-show="!isSeishain" :disabled="menuDisable">業務報告</el-menu-item>
      <el-menu-item index="/shuho" :disabled="menuDisable">週報入力</el-menu-item>
      <el-submenu id="sonota-drop" index="/sonota" v-if="isMobile">
        <template slot="title">その他</template>
        <el-menu-item index="/shokai" :disabled="menuDisable" popper-class="sub-menu-item">週報照会</el-menu-item>
        <el-menu-item index="/jokyo" :disabled="menuDisable" popper-class="sub-menu-item">状況照会</el-menu-item>
        <el-menu-item index="/shain" v-show="isSeishain" :disabled="menuDisable" popper-class="sub-menu-item">社員設定</el-menu-item>
        <el-menu-item index="/shainK" v-show="!isSeishain" :disabled="menuDisable" popper-class="sub-menu-item">社員設定</el-menu-item>
        <el-menu-item index="/kintai" v-show="isRomu" :disabled="menuDisable">勤 怠 届</el-menu-item>
      </el-submenu>
      <template v-if="!isMobile">
        <el-menu-item index="/shokai" :disabled="menuDisable">週報照会</el-menu-item>
        <el-menu-item index="/jokyo" :disabled="menuDisable">状況照会</el-menu-item>
        <el-menu-item index="/shain" v-show="isSeishain" :disabled="menuDisable">社員設定</el-menu-item>
        <el-menu-item index="/shainK" v-show="!isSeishain" :disabled="menuDisable">社員設定</el-menu-item>
        <el-menu-item index="/kintai" v-show="isRomu" :disabled="menuDisable">勤 怠 届</el-menu-item>
      </template>
    </el-menu>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      windowWidth: 0,
    }
  },
  created() {
    this.handleResize();
    let today = this.$moment();
    if (this.$store.state.kimmuBi == null) {
      this.$store.commit('setKimmuBi', today.format('YYYY-MM-DD'));
    }
    if (this.$store.state.nengetsu == null) {
      today = this.$moment();
      if (today.get('date') > 20) {
        today.add(1, 'months');
      }
      this.$store.commit('setNengetsu', today.format('YYYY-MM'));
    }
    // 今日が日・月・火の場合は前週の、それ以外は今週の、月曜日を初期値とする。
    if (this.$store.state.torokuBi == null) {
      today = this.$moment();
      this.$store.commit('setTorokuBi', today.subtract(3, 'days').startOf('weeks').add(1, 'days').format('YYYY-MM-DD'));
    }
    if (this.$store.state.nen == null) {
      today = this.$moment();
      this.$store.commit('setNen', today.format('YYYY'));
    }
  },
  computed: {
    isScc() {
      return false;
    },
    isRomu() {
      return this.getKengenKubun() >= '700';
    },
    isSeishain() {
      return (this.getShainKubun() ?? '1') == '1';
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    userName() {
      return this.$store.getters.shainShimei;
    },
    menuDisable() {
      return this.$store.state.menuDisable;
    },
    menuId() {
      if (this.isMobile) {
        return 'menu';
      } else if (this.isRomu) {
        return 'menu-romu';
      } else {
        return 'menu-wide';
      }
    },
    activeIndex() {
      let endOfPath = this.$route.path.indexOf("/", 1);
      if (endOfPath < 0) {
        return this.$route.path;
      } else {
        return this.$route.path.substring(0, endOfPath);
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      //this.windowWidth = window.innerWidth;
      this.windowWidth = document.documentElement.clientWidth;
    },
    isGenechMailUser(shainId) {
      const inc = "@genech.co.jp";
      if (shainId) {
        return shainId.includes(inc);
      } else {
        return this.getShainId().includes(inc);
      }
    },
    switchMenu(name, path, param) {
      this.$refs['menu'].activeIndex = path;
      if (param === undefined) {
        this.$router.push({name: name});
      } else {
        this.$router.push({name: name, params: param});
      }
    },
    setUser(user) {
      this.$store.commit('setLoginUser', user);
    },
    setJochoShainIds(jochoShainIds) {
      this.$store.commit('setJochoShainIds', jochoShainIds);
    },
    enableMenu() {
      this.$store.commit('setMenuDisable', false);
    },
    disableMenu() {
      this.$store.commit('setMenuDisable', true);
    },
    setKimmuBi(kimmuBi) {
      this.$store.commit('setKimmuBi', kimmuBi);
    },
    setNengetsu(nengetsu) {
      this.$store.commit('setNengetsu', nengetsu);
    },
    setTorokuBi(torokuBi) {
      this.$store.commit('setTorokuBi', torokuBi);
    },
    setNen(nen) {
      this.$store.commit('setNen', nen);
    },
    getKimmuBi() {
      return this.$store.state.kimmuBi;
    },
    getNengetsu() {
      return this.$store.state.nengetsu;
    },
    getTorokuBi() {
      return this.$store.state.torokuBi;
    },
    getNen() {
      return this.$store.state.nen;
    },
    getLoginUser() {
      return this.$store.state.loginUser;
    },
    getShainId() {
      return this.$store.getters.shainId;
    },
    getShainShimei() {
      return this.$store.getters.shainShimei;
    },
    getKengenKubun() {
      return this.$store.getters.kengenKubun;
    },
    getJochoIds() {
      return this.$store.getters.jochoIds;
    },
    getShainKubun() {
      return this.$store.getters.shainKubun;
    },
  }
}
</script>

<style>
#app {
  font-size: 12pt;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
#header {
  width: 340px;
  height: 24px;
  margin-left: auto;
  margin-right: auto;
}
#user {
  font-size: 10pt;
  font-style: italic;
  color: rosybrown;
  display: inline-block;
  width: 130px;
  text-align: right;
  vertical-align: top;
  line-height: 0.98;
}
#menu {
  width: 330px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}
#menu-wide {
  width: 494px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}
#menu-romu {
  width: 568px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}
#menu li {
  height: 40px;
  line-height: 40px;
  padding: 0px 13px;
}
#menu-wide li {
  height: 40px;
  line-height: 40px;
  padding: 0px 13px;
}
#menu-romu li {
  height: 40px;
  line-height: 40px;
  padding: 0px 13px;
}
#sonota-drop {
  padding: 0px 0px !important;
}
.sub-menu-item {
  width: 20px;
  padding: 0px 0px !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
}
.el-submenu__title {
  padding: 0 10px !important;
}
</style>
